import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    applicationsList: [],
    applicationsDropdownList: [],
    usersApplicationsList: [],
    applicationsRecord: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const ApplicationReducer = (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.APPLICATIONS_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.APPLICATIONS_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
                applicationsRecord: [],
            }
        case actionTypes.APPLICATIONS_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                applicationsList: action.applicationsList,
                showUpdateForm: false,
                showViewPage: false,
                applicationsRecord: [],
            }
        case actionTypes.USERS_APPLICATIONS_LIST_SUCCESS:
            return {
                ...state,
                Loading: false,
                usersApplicationsList: action.usersApplicationsList,
            }
        case actionTypes.APPLICATIONS_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                Loading: false,
                applicationsDropdownList: action.applicationsDropdownList,
            }
        case actionTypes.APPLICATIONS_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                applicationsRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes.APPLICATIONS_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_APPLICATIONS_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes.REDIRECT_TO_APPLICATIONS_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: '',
                applicationsRecord: [],
            }
        default:
            return state;
    }
}

export default ApplicationReducer;